<template>
  <div class="share-button" @click="click">
    <div class="share-button__icon">
      <slot name="icon"></slot>
    </div>
    <div class="share-button__title">
      <slot name="title"></slot>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
export default {
  name: 'BaseShareButton',
  methods: {
    click() {
      $emit(this, 'click')
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.share-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    width: 50px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    margin-top: 7px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #585f6d;

    &:empty {
      margin-top: 0;
    }
  }
}
</style>
